import * as React from 'react';
import {
	Dropdown,
	DropdownContent,
	DropdownEllipsisTrigger,
	DropdownItem,
} from '../../../../web/components-v2/Dropdown';

interface IProps {
	onClickToClone: (() => void) | null;
	onClickToDelete: (() => void) | null;
	onClickToEdit: (() => void) | null;
	onClickToEditSchedule: (() => void) | null;
}

export const RuleOptions: React.FC<IProps> = ({
	onClickToClone,
	onClickToDelete,
	onClickToEdit,
	onClickToEditSchedule,
}) => {
	return (
		<Dropdown>
			<DropdownEllipsisTrigger />
			<DropdownContent>
				<DropdownItem onClick={onClickToEditSchedule}>Edit Schedule</DropdownItem>
				{onClickToEdit && <DropdownItem onClick={onClickToEdit}>Edit</DropdownItem>}
				{onClickToClone && <DropdownItem onClick={onClickToClone}>Clone</DropdownItem>}
				{onClickToDelete && <DropdownItem onClick={onClickToDelete}>Delete</DropdownItem>}
			</DropdownContent>
		</Dropdown>
	);
};
